<template>
	<div class="consumer-login-container">
		<div class="consumer-login" @click="onClick">
			<p class="consumer-text">{{ loggedIn ? displayName : getString('consumer_login_track_orders') }}</p>
			<div class="consumer-avatar">
				<img v-if="loggedIn && pictureUrl" :src="pictureUrl" alt=""/>
				<span v-else class="consumer-avatar-fallback" v-html="getIcon('iconPerson')"></span>
			</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import API from "@/shared/helpers/API";

export default {
	name: "ConsumerLogin",
	setup() {
		let svgStore = useSvgStore();
		return {getString: useLanguageStore().getString, getIcon: svgStore.get};
	},
	data() {
		return {
			loggedIn: false,
			name: "",
			pictureUrl: null,
		};
	},
	computed: {
		displayName() {
			return (this.name || "").trim() || this.getString('consumer_go_to_profile');
		},
	},
	mounted() {
		this.fetchConsumerIdentity();
	},
	methods: {
		// Any non-OK / error is treated as logged-out.
		fetchConsumerIdentity() {
			API.init().getConsumerIdentity((response) => {
				if (response && response.result === "OK" && response.consumer) {
					this.loggedIn = true;
					this.name = response.consumer.name || "";
					this.pictureUrl = response.consumer.picture_url || null;
				}
			}, () => {
				// Error / not logged in → stay logged-out, no menu disruption.
			});
		},
		onClick() {
			// Persist a return URL so auth can bounce the consumer back to this exact menu page.
			let returnUrl = encodeURIComponent(window.location.href);
			if (this.loggedIn) {
				window.location.href = URL_HTML + "/consumer/merchants";
			} else {
				window.location.href = URL_HTML + "/consumer/login?return_url=" + returnUrl;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.consumer-login-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;

	.consumer-login {
		display: flex;
		align-items: center;
		width: 100%;
		padding: var(--padding-vertical) var(--padding-horizontal-s);
		gap: 12px;
		cursor: pointer;
		background-color: var(--theme-bg2-color);
		border-radius: var(--rounded-corner);
		transition: opacity 0.2s ease-in-out;

		&:hover {
			opacity: 0.8;
		}

		.consumer-text {
			flex: 1 0 0;
			min-width: 0;
			margin: 0;
			font-family: var(--font-family);
			font-size: var(--font-size);
			line-height: var(--line-height);
			color: var(--theme-txt1-color);
			word-break: break-word;
		}

		.consumer-avatar {
			flex-shrink: 0;
			width: 20px;
			height: 20px;

			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			.consumer-avatar-fallback {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				height: 100%;
				opacity: 0.6;

				:deep(svg) {
					width: 100%;
					height: 100%;

					.fill {
						fill: var(--business-color);
					}

					.stroke {
						stroke: var(--business-color);
					}
				}
			}
		}
	}
}
</style>